export default class WwcForm {
  constructor (rawData = {}) {
    this.id = rawData.id
    this.name = rawData.name
    this.pivot = rawData.pivot
    this.description = rawData.description || this.getDescription(rawData.orderby)
    this.actionButtonText = this.getButtonText(rawData.orderby)
    this.component = this.geComponentName(rawData.orderby)
    this.isChooseLocation = rawData.orderby === 4
    // todo
    this.redirect_link = rawData.redirect_link || 'http://www.workingwithchildren.vic.gov.au'
  }

  getDescription (orderBy) {
    const data = [
      null,
      'Learn about the [number_name] working with Children Check and how to apply for certificate for your location using the links below.',
      null,
      'Verify your clearance in another State or Territory.'
    ]
    return data[orderBy - 1]
  }

  getButtonText (orderBy) {
    const data = [
      null,
      null,
      null,
      'Choose location'
    ]
    return data[orderBy - 1]
  }

  geComponentName (orderBy) {
    const data = [
      'WwcFormA',
      null,
      'WwcFormB',
      'WwcFormA'
    ]
    return data[orderBy - 1]
  }
}



// WEBPACK FOOTER //
// ./src/models/WwcFormClass.js